var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Colors, helperButtonReset, helperLinkReset } from '@utex/ui-kit';
function getUnderlineColor(props) {
    if (props.isActive) {
        switch (props.view) {
            case 'white':
                return Colors.text.inverse;
            case 'black':
                return Colors.text.default;
            default:
                return Colors.ut.alert;
        }
    }
    return 'transparent';
}
export var Container = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n\n  @media (max-width: 1200px) {\n    display: none;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n\n  @media (max-width: 1200px) {\n    display: none;\n  }\n"])));
export var Item = styled('a')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 0.8rem 0 0.8rem;\n  margin-bottom: -2px;\n  border-bottom: 2px solid ", ";\n  color: inherit;\n  transition: opacity 0.3s, color 0.3s, border-bottom 0.3s;\n\n  &:not(:last-child) {\n    margin-right: 3rem;\n  }\n\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 0.8rem 0 0.8rem;\n  margin-bottom: -2px;\n  border-bottom: 2px solid ", ";\n  color: inherit;\n  transition: opacity 0.3s, color 0.3s, border-bottom 0.3s;\n\n  &:not(:last-child) {\n    margin-right: 3rem;\n  }\n\n  ",
    ";\n"])), helperLinkReset, helperButtonReset, function (props) { return getUnderlineColor(props); }, function (props) {
    return !props.isActive && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      &:hover,\n      &:focus {\n        opacity: 0.5;\n      }\n\n      &:active {\n        opacity: 1;\n      }\n    "], ["\n      &:hover,\n      &:focus {\n        opacity: 0.5;\n      }\n\n      &:active {\n        opacity: 1;\n      }\n    "])));
});
export var dropdown = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  top: 0.7rem;\n  right: -1.7rem;\n"], ["\n  position: absolute;\n  top: 0.7rem;\n  right: -1.7rem;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/Navigation/styles.js
// module id = 1362
// module chunks = 118